<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>回购管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>


		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="银行">
				<el-select v-model="formInline.city" placeholder="选择银行" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="日期">
					<el-date-picker v-model="formInline.analysisDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="有效性：" label-width="160px">
					<el-select clearable v-model="formInline.isValid" style="width:200px">
						<el-option label="有效" value="yes"></el-option>
						<el-option label="无效" value="no"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="方向：" label-width="160px">
					<el-select clearable v-model="formInline.direction" style="width:200px">
						<el-option label="逆回购" value="reverse"></el-option>
						<el-option label="正回购" value="positive"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="利率等于当日加权利率：" label-width="160px">
					<el-select clearable v-model="formInline.isRateSameQuote" style="width:200px">
						<el-option label="是" value="yes"></el-option>
						<el-option label="否" value="no"></el-option>
					</el-select>
				</el-form-item>
				
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="warning" @click="exportData">导出</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(327)">新增</el-button>
				<el-button size="small" type="primary" icon="el-icon-search" @click="updateBuyBackTransction" v-if="jurisdiction.includes(330)" >更新数据</el-button>
				


				<el-form-item>
				<el-upload
				:action=url
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:on-success="handleSuccess"
				multiple
				:with-credentials="true"
				:file-list="fileList">
				<el-button  type="danger" @click="handlePreview"  v-if="jurisdiction.includes(327)">导入</el-button>
				</el-upload>
				<!-- <el-upload
				:action=url
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:on-preview="handlePreview"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				multiple
				:limit="limitUpload"
				:on-exceed="handleExceed"
				:with-credentials="true"
				:headers="headers"
				:file-list="fileList">
				<el-button  type="danger" @click="handlePreview"  v-if="jurisdiction.includes(327)">导入</el-button>
				</el-upload> -->
			</el-form-item>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" 
			:row-style='changeRowBgColor'>
			<el-table-column prop="city" label="银行" align="center"></el-table-column>
			<el-table-column prop="direction" label="方向" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.direction=='positive'">正回购</div>
						<div v-else-if="scope.row.direction=='reverse'">逆回购</div>
						<div v-else>-</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="isValid" label="有效性" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if="scope.row.isValid=='yes'">有效</div>
						<div v-else-if="scope.row.isValid=='no'">无效</div>
						<div v-else>-</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="buyBackCode" label="回购代码" align="center"></el-table-column>
			<el-table-column prop="tradingDate" label="交易日期" align="center"></el-table-column>
			<el-table-column prop="dueDate" label="到期日期" align="center"></el-table-column>
			<el-table-column prop="v" label="交易金额【万】" align="center"></el-table-column>
			<el-table-column label="利率【%】" align="center">
				<template slot-scope="scope">
                  <div >
                        <div>{{scope.row.rate}}</div>
						<div v-if="scope.row.isRateSameQuote==='no'">[{{scope.row.rateQuote}}]</div>
                </div>
                </template>
			</el-table-column>
			<el-table-column prop="period" label="期限" align="center"></el-table-column>
			<el-table-column prop="income" label="收入" align="center"></el-table-column>
			<!-- <el-table-column prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
			<el-table-column prop="counterparty" label="交易对手" align="center"></el-table-column> -->

			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;" v-if="jurisdiction.includes(327)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)" v-if="jurisdiction.includes(328)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		
		<div v-if="staData">
			<el-card shadow="never" >
				<el-row>
					<el-col :span="4">
						<div>笔数：{{staData.count}}</div>
					</el-col>
					<el-col :span="4">
						<div>金额：{{towNumber(staData.sum,2)}}</div>
					</el-col>
				</el-row>
			</el-card>
		</div>


			<el-table-column prop="" label="" align="center"></el-table-column>
			<el-table-column prop="" label="" align="center"></el-table-column>
			<el-table-column prop="income" label="收入" align="center"></el-table-column>
	
			<el-table-column prop="counterparty" label="交易对手" align="center"></el-table-column>


		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form  :model="editForm" ><!--:rules="rules" -->
				<el-form-item label="银行：" label-width="160px">
					<el-select v-model="editForm.city" placeholder="选择银行" clearable  style="width:200px">
						<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="方向：" label-width="160px">
					<el-select clearable v-model="editForm.direction" style="width:200px"  @change="handleInputChange" >
						<el-option label="正回购" value="positive"></el-option>
						<el-option label="逆回购" value="reverse"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="有效性：" label-width="160px">
					<el-select clearable v-model="editForm.isValid" style="width:200px">
						<el-option label="有效" value="yes"></el-option>
						<el-option label="无效" value="no"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="回购代码：" label-width="160px">
					<el-select v-model="editForm.buyBackCode" placeholder="选择回购代码" clearable style="width:200px">
						<el-option :label="item" :value="item" v-for="(item,key) in buyBackCodes"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="买入金额【万】：" label-width="160px" >
					<el-input v-model="editForm.v" type="number"  @change="handleInputChange"  style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="交易日期：" label-width="160px">
					<el-date-picker v-model="editForm.tradingDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="到期日期：" label-width="160px">
					<el-date-picker v-model="editForm.dueDate" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
				</el-form-item>
				<el-form-item label="利率【%】:" label-width="160px">
					<el-input v-model="editForm.rate"   type="number" @change="handleInputChange" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="期限【天】:" label-width="160px">
					<el-input v-model="editForm.period" type="number" @change="handleInputChange" style="width:200px"></el-input>
				</el-form-item>
				<el-form-item label="收入【元】:" label-width="160px">
					<el-input v-model="editForm.income" type="number" style="width:200px"></el-input>
				</el-form-item>
				<!-- <el-form-item label="债券代码：" label-width="160px">
					<el-input v-model="editForm.bondCode" style="width:200px" ></el-input>
				</el-form-item>
				<el-form-item label="交易对手:" label-width="160px">
					<el-input v-model="editForm.counterparty" style="width:200px"></el-input>
				</el-form-item> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取消</el-button>
			<el-button type="primary" @click="addEdit" >提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import {
		getAllCity,
		getManageCity,
		getAllBuyBackCodes,
		addEditBuyBack,
		delBuyBack,
		getBuyBackList,
		getBuyBackListSta,
		getBuyBackListExport,
		updateBuyBackTransction
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				url:localStorage.getItem("baseUrl")+"/manager/bond/importBuyBackTransaction",
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				cityList: [],
				manageCityList:[],
				buyBackCodes:[],
				analysisMap:{},
				staData:{},
				listData: [],
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],

				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',
				dialogVisible: false,
				// 所属分类
				tableData: [],
				value: [],
				editForm: {},
				selectEditForm: {},
				usernames: ''
			}
		},
		watch: {},
		methods: {
			handleInputChange() {
				console.log('输入完成');
				this.editForm.income=this.editForm.rate*this.editForm.v*this.editForm.period*10000/100/365;
				if (this.editForm.direction==='positive'){
					this.editForm.income=-this.editForm.income
				}
				this.editForm.income=(Math.round(this.editForm.income * 100)/100).toFixed(2)
			},
			// 文件上传成功时的钩子
			handleSuccess(response, file, fileList, rowInfo) {
				console.log(response, file, fileList, rowInfo);
			},

			towNumber(val,len) {
				return parseFloat(val).toFixed(len)    
			},
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.isRateSameQuote === 'no'){
				styleJson = { "color": "red" };} 
				return styleJson
			},
			updateBuyBackTransction(){
				let param = this.formInline
				updateBuyBackTransction(param).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
			},
			getAllCity() {
				getAllCity().then(res => {
					if (res.code == '200') {
						this.cityList = res.data
					}
				})
				getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
			},
			getAllBuyBackCodes(){
				getAllBuyBackCodes().then(res => {
					if (res.code == '200') {
						this.buyBackCodes = res.data
					}
				})
			},
						// 获得数据
			getdata() {
				let param = this.formInline
				getBuyBackList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
				getBuyBackListSta(param).then(res => {
                this.saveParams(this.$route.path, param);
                if (res.code == "200") {
                    this.staData = res.data;
                }
            });
			},
			exportData() {
				let param = this.formInline
				getBuyBackListExport(param)
			},

			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditBuyBack(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },

			// 删除
			handledelete(row) {
				let msg = '确认删除?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delBuyBack({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},



		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getAllCity()
			this.getAllBuyBackCodes()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>